// SelectorCategoria.js
import { useEffect, useState, useRef } from "react";
import { useCategorias } from "../../../../contexto/provider/CategoriasContext.js";

import iconDefault from "../../../../../assets/img/icons/categorias/default.svg";
import "./categorias.css";
import SubTituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloSubModulo.js";

const SelectorCategoria = ({ onCategoriaChange }) => {
  const { categorias, cargarCategorias, cargando } = useCategorias();
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const contenedorRef = useRef(null);

  useEffect(() => {
    cargarCategorias();
  }, [cargarCategorias]);

  const seleccionarCategoria = (categoria) => {
    setCategoriaSeleccionada(categoria);

    if (onCategoriaChange) {
      onCategoriaChange(categoria); // objeto o null
    }
  };

  return (
    <div className="selector-container">
      <SubTituloModulo subtitulo="Seleccionar categoria" />
      <div className="categorias-scroll" ref={contenedorRef}>
        {/* TODAS */}
        <button
          className={`categoria-bloque ${
            categoriaSeleccionada === null ? "seleccionado" : ""
          }`}
          onClick={() => seleccionarCategoria(null)}
        >
          <div className="categoria-icono">
            <img src={iconDefault} alt="Todas" />
          </div>
          <div className="categoria-titulo">Todas</div>
        </button>

        {/* CATEGORÍAS */}
        {!cargando &&
          categorias.map((cat) => (
            <button
              key={cat.id}
              className={`categoria-bloque ${
                categoriaSeleccionada?.id === cat.id ? "seleccionado" : ""
              }`}
              onClick={() => seleccionarCategoria(cat)}
            >
              <div className="categoria-icono">
                <img src={iconDefault} alt={cat.nombre} />
              </div>
              <div className="categoria-titulo">{cat.nombre}</div>
            </button>
          ))}
      </div>
    </div>
  );
};

export default SelectorCategoria;
